module.exports = __webpack_public_path__ + "components/home-header/static/header-7--large-3e54163f2c923ddd8e10512ac1da7e38.jpg";